<template>
  <page>
    <template slot="content">
    <help-content :title="'位置情報を要求するダイアログが表示される理由(Android)'">
      <template slot="content">
        <div class="text">
          WeBandはBLE（Bluetooth）技術を利用してスマホとペアリングしています。Android6.0からBLEの利用には位置情報の機能、権限を共にオンにする必要があります。位置情報に関わる機能を利用されない場合でも、位置情報の機能および権限をオンにすることはおすすめです。<br><br>
          ※位置情報をオンにしても、利用者がウォーク／ラン機能を利用している場合を除き、WeRUNアプリが現在地情報をどこにも保存しません。<br><br>
          ※WeBandご利用の場合、アプリが正しく実行するために必要な権限はコチラ↓です。(Android11の場合、「ストレージ」が「ファイルとメディア」に変わり、新たに追加された「身体活動」も必要です。)
        </div>
        <img class="picture" src="../assets/images/q_and_a/H21.png">
        <img class="picture" src="../assets/images/q_and_a/H3_0.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help21.vue